export default __webpack_public_path__ + "static/media/globe.63a77f78.svg";